export default __webpack_public_path__ + "static/media/mancha.2fb61f19.png";